
import request from '@/utils/server'
 

// 新增生产任务
export function addProduction(data) {
    return request({
      url: '/production/addProduction',
      method: 'POST',
      data:data
    })
  }
  // 列表
  export function getProductionList(query) {
    return request({
      url: '/production/getProductionList',
      method: 'get',
     params: query
    })
  }
  // 分配
   export function updateProductionStatus(data) {
    return request({
      url: '/production/issue',
      method: 'POST',
 data:data
    })
  }